export const CASES = {
    SENSITIVE: 'sensitive',
    INSENSITIVE: 'insensitive'
} as const;

export const OPERATORS = {
    EQUALS: 'equals',
    CONTAINS: 'contains'
} as const;


export const ORDERS = {
    ASC: 'asc',
    DESC: 'desc'
} as const;

export type SearchCase = typeof CASES[keyof typeof CASES];
export type SearchOperator = typeof OPERATORS[keyof typeof OPERATORS];

export type SearchOrder = typeof ORDERS[keyof typeof ORDERS];